import IPublic from '@/interface/public'
import { rootStore } from "@/store";
import { Modal, IProps, IRecentPlayGs } from "@/views/component/modal";
import { EModal } from "@/interface/enum";

function login() {
  f2eGame.port.udb.login({
    url: (window.location.href).split('#')[0],
    type: "YYC",
    tabIndex: 0,
    beta: true,
  })
}

function logout() {
  const bool = window.confirm("确认退出登录?");
  if (bool) {
    f2eGame.port.udb.logout();
  }
}

function verifyLogin(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    f2eGame.port.udb.isLogin().then((res: boolean) => {
      resolve(res);
    })
  })
}

// 请求失败时调用的函数=>弹窗提示
function catchModal(type: EModal, option: Partial<IProps>) {
  $refPopup.current.open((props: any) => Modal({
    ...props,
    modalType: type,
    ...option
  }));
}

// 图片url
function defaultGameImgUrl(gameId: string, w?: number, h?: number, exName: string = 'png'): string {
  const baseUrl = '//download.game.yy.com/goa/pic/o/';
  gameId = gameId.toLocaleLowerCase();

  if (undefined !== w && undefined !== h) {
    return `${baseUrl}${gameId}_${w}x${h}.${exName}`;
  } else if (undefined !== w) {
    return `${baseUrl}${gameId}_${w}.${exName}`;
  } else if (undefined !== h) {
    return `${baseUrl}${gameId}_${h}.${exName}`;
  }
  return `${baseUrl}${gameId}.${exName}`;
}

// 获取渠道，属性
function getUrlParams(): IPublic.UrlParams {
  const codeString = f2eGame.util.getQueryString('code');
  const hd = f2eGame.util.getQueryString('hd');

  let HD_KEY = Object.keys(CONFIG.HD)[0];
  let QD_KEY = Object.keys(CONFIG.QD)[0];
  let AW_KEY = Object.keys(CONFIG.AW)[0];

  if (codeString && codeString.indexOf('IV') >= 0) {
    QD_KEY = codeString.split('IV')[0];
    AW_KEY = codeString.split('IV')[1];
  }
  if (Object.keys(CONFIG.HD).includes(hd)) {
    HD_KEY = hd;
  }

  return {
    QD: [QD_KEY || '', CONFIG.QD[QD_KEY] || ''],
    AW: [AW_KEY || '', CONFIG.AW[AW_KEY] || ''],
    HD: [HD_KEY || '', CONFIG.HD[HD_KEY] || ''],
    pro: 'yygame'
  };
}

// 开始游戏
function playGame(gameId: string, serverId: string, index: number | undefined = undefined) {
  const [QD, QD_DESC] = rootStore.store.urlParams.QD;
  const [AW, AW_DESC] = rootStore.store.urlParams.AW;
  const [HD, HD_DESC] = rootStore.store.urlParams.HD;

  const eid = index === undefined ? '' : `${QD}/${HD}/${AW}/yx${index + 1}`;//上报来源
  const eid_desc = index === undefined ? '' : `${QD_DESC}/${HD_DESC}/${AW_DESC}/游戏${index + 1}`;//上报来源描述

  console.log('=========', {
    gameId,
    serverId,
    eid: eid,
    eid_desc: eid_desc
  });
  f2eGame.port.statpid.gameStat({
    gameId,
    serverId,
    eid: eid,
    eid_desc: eid_desc
  });
}

// 登录埋点
function loginStat(): void {
  const {
    QD: [QD, QD_DESC],
    HD: [HD, HD_DESC]
  } = rootStore.store.urlParams;

  const eid = `login/${QD}/${HD}`;
  const eid_desc = `登录/${QD_DESC}/${HD_DESC}`;

  f2eGame.port.statpid.loginStat({
    eid,// 上报eid
    eid_desc,// 上报eid描述
    pro: 'yygame', // 产品名称
  });
}

// 点击埋点
function statClick(eid?: string, eidDesc?: string): void {
  const {
    QD: [QD, QD_DESC],
    HD: [HD, HD_DESC],
  } = rootStore.store.urlParams;

  f2eGame.port.statpid.clickStat({
    eid: eid ? `click/${QD}/${HD}/${eid}` : `click/${QD}/${HD}`,
    eid_desc: eidDesc ? `点击/${QD_DESC}/${HD_DESC}/${eidDesc}` : `点击/${QD_DESC}/${HD_DESC}`,
  });
}

// 获取当天23.59.58的时间
function getDayEndTime() {

  return new Date(new Date().setHours(23, 59, 59));
}

// 过滤当月游戏列表
function filterMonthGame(serverList: IRecentPlayGs[]) {
  const curMonth = new Date().getMonth() + 1;
  console.log('curMonth', curMonth);
  const _ = [];
  for (const item of serverList) {
    // 必须替换,否则IE不兼容
    item.playTime = item.playTime.replace(' ', 'T');
    const thisMonth = new Date(item.playTime).getMonth() + 1;
    if (thisMonth === curMonth) {
      _.push(item);
    }
  }

  return _;
}

function random(max: number) {
  return Math.floor(Math.random() * max)
}

export {
  login,
  logout,
  verifyLogin,
  catchModal,
  playGame,
  getUrlParams,
  loginStat,
  statClick,
  defaultGameImgUrl,
  getDayEndTime,
  filterMonthGame,
  random
}
